
import { barneyMediaArray } from './barneyMedia'
import { tedReviewerProfile, robinReviewerProfile } from './barneyReviewers'
import { barneyBio, tedBio, robinBio } from './barneyBios'
import { barneyDatingProfileHinge, barneyDatingProfileBumble, barneyDatingProfileTinder } from './barneyDatingProfiles'

export const barneyUser = {
  _id: 'barneyUserId',
  email: 'barney@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...tedReviewerProfile },
    { ...robinReviewerProfile }
  ],
  media: [ ...barneyMediaArray ],
  bio: { ...barneyBio },
  datingProfiles: [
    { ...barneyDatingProfileHinge },
    { ...barneyDatingProfileBumble },
    { ...barneyDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const tedUser = {
  _id: 'tedUserId',
  email: 'ted@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...tedBio },
  datingProfiles: [],
  reviewerProfile: { ...tedReviewerProfile },
}

export const robinSUser = {
  _id: 'robinUserId',
  email: 'robin@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...robinBio },
  datingProfiles: [],
  reviewerProfile: { ...robinReviewerProfile },
}
